import React, { forwardRef } from 'react';
import utils from 'utils';
import { isDuplicateEmailError } from 'utils/profile';
import PropTypes from 'prop-types';
import cn from 'classnames';
import GMA_RESPONSE_CODES from 'constants/gmaResponseCodes';
import Anchor from 'components/Anchor';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import { sanitize } from 'utils/validation';
/**
 * GenericError Description
 *
 * @param {object} props - React Props
 * @param {array}  props.errors - array of errors
 * @param {string||array} props.description - a string description or array of elements explaining errors
 * @return {JSX}
 */

const GenericError = forwardRef(({ errors, description, setHtmlContent }, ref) => (
  <div className='service-errors' ref={ref} role='alert' tabIndex='-1'>
    {errors.map(({ message, priority = 'ERROR', code }, index) => {
      const isEmailInUse = isDuplicateEmailError(code);
      const errorStatus = priority !== 'ERROR' ? 'ERROR' : priority;
      const reservationStatusCLosed = code === GMA_RESPONSE_CODES.GBO_RESERVATION_STATUS_CLOSED;
      return (
        <div
          key={index}
          className={cn('service-error', {
            'service-errors_duplicate-email': isEmailInUse,
          })}
        >
          <span className={`message-priority--${errorStatus}`}>
            {isEmailInUse
              ? utils.i18n('email_already_in_use_modal_error_heading')
              : utils.i18n(`message_priority_${priority}`)}
          </span>

          {(message || reservationStatusCLosed) && (
            <p>
              {message}
              {reservationStatusCLosed && (
                <Anchor
                  className='link--arrow-spacing link--arrow'
                  href={utils.config.getRedirectUrl(WINDOW_OBJECT_KEYS.RECEIPTS_PAGE)}
                >
                  {utils.i18n('past_trips_unauth_page_title')}
                </Anchor>
              )}
            </p>
          )}
        </div>
      );
    })}

    {!!description && !setHtmlContent && <p className='service-errors__description'>{description}</p>}
    {!!description && setHtmlContent && (
      <p className='service-errors__description' dangerouslySetInnerHTML={sanitize(description)} />
    )}
  </div>
));

GenericError.propTypes = {
  errors: PropTypes.array,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  setHtmlContent: PropTypes.bool,
};

export default GenericError;
